import * as cnt from '../../__storeFiles__/constants';

const initialState = {
  sendingUpdates: false,
  updateProcessInitiated: false,
  error: null,
};
export function supplierUpdatesQueue(state = initialState, { type, payload }) {
  switch (type) {
    case `${cnt.SEND_UPDATES_FROM_QUEUE}_STARTED`:
      return {
        ...state,
        sendingUpdates: true,
      };
    case `${cnt.SEND_UPDATES_FROM_QUEUE}_SUCCESS`:
      return {
        ...state,
        sendingUpdates: false,
        updateProcessInitiated: true,
      };
    case `${cnt.SEND_UPDATES_FROM_QUEUE}_ERROR`:
      return {
        ...state,
        sendingUpdates: false,
        updateProcessInitiated: false,
        error: 'Uh Oh! There is an error preventing us from issuing your updates. Please send us a message through live chat, we will take care of this.',
      };
    case cnt.CLEAR_QUEUE_STATE:
      return initialState;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/contracting/supplier-updates-queue/__storeFiles__/reducer.js